import { Box } from "@chakra-ui/react";
import { Avatar } from "@components/ui-kit/avatar";
import type { AvatarPlaceholderProps } from "@components/ui-kit/avatar/variants/placeholder/types";
import { Icon } from "@components/ui-kit/Icon";

/** Dashed "+" avatar, e.g. for adding a user. */
export const AvatarPlaceholder = ({
  label,
  isHighlighted,
  ...props
}: AvatarPlaceholderProps) => {
  const color = isHighlighted ? "violet.500" : "gray.500";

  return (
    <Avatar
      // The ring a group or highlight adds, so a lone placeholder isn't bigger
      borderWidth="2px"
      borderColor="transparent"
      {...props}
      aria-label={label}
      colorScheme="white"
      tooltip={label}
      icon={
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          boxSize="100%"
          color={color}
          borderWidth="1px"
          borderStyle="dashed"
          borderColor={color}
          rounded="full"
        >
          <Icon name="plus" />
        </Box>
      }
    />
  );
};
